export default {

// TOP SECTION

    title: `de l’autre côté du miroir`,
    subTitle: `Arty`,
    authorName:`Valérie Belin`,
    authorTitle:`Artiste plasticienne`,

    intro:`<p><strong>Par Chloé Perrin, journaliste culturelle</strong></p>
    <p><em>« Sans titre (97070804) »</em> est issue de la série <em>« Venise (Miroir) »</em>, réalisée en 1997, où la propriété de réflexion et la transparence du verre de Murano font du miroir vénitien une pure matérialisation de la lumière. Cette œuvre, acquise pour la <span class="renvoi" data-tippy-content="À voir <br/>Collection Société Générale, La Défense, France. Visite sur réservation : <a href='http://www.collectionsocietegenerale.com' target='_blank'>www.collectionsocietegenerale.com</a>">Collection du groupe Société Générale</span> en 2007, est emblématique du travail de la photographe Valérie Belin, dont la dernière série, <span class="renvoi" data-tippy-content="<em>Reflection</em>, de Valérie Belin, au V&A Photography Center, Cromwell Road, SW7 2RL, à Londres, jusqu’au 20 août 2020."><em>« Reflection »</em></span>, est actuellement exposée au V&A Photography Center de Londres.</p>`,


// CAPTIONS

    imageCaption: `Sans Titre (90070804), <br/>
    série Venise (Miroir), <br/>
    de Valérie Belin, 1997.`,


// ARTICLES

    articles: [
        {
            title:`Entre matière et lumière`,
            content:`« Plus que de la représentation d’un miroir, il s’agit d’une photo de son spectre lumineux. » C’est ainsi que Valérie Belin présente <em>Miroirs</em>. <br/>
            Ces miroirs vénitiens qui ne reflètent personne ne peuvent que se refléter eux-mêmes, créant une impression d’infini et d’absurdité dans laquelle on retrouve l’esprit des vanités baroques. L’humain brille par son absence. <br/>
            De fait, <em>Venise</em> est la dernière série de la photographe avant des travaux consacrés à la figure humaine. Précédée d’une réflexion sur les cristaux et l’argenterie, elle est emblématique de sa démarche sur la lumière, la matière et leurs qualités intrinsèques. Née en 1964 à Boulogne-Billancourt, Valérie Belin étudie aux Beaux-Arts de Versailles et à l’École nationale supérieure d’art de Bourges, puis approfondit ses recherches en philosophie de l’art à la Sorbonne. Dès ces premières années, c’est la photographie qui retient son attention : influencée par le minimalisme de Robert Morris ou de Robert Ryman et par l’art conceptuel, elle l’envisage à la fois comme médium et comme sujet.`,
        },
        {
            title:`Une œuvre variée mais cohérente`,
            content:`En à peine trente ans et pas moins de quarante-cinq séries, Valérie Belin a créé une œuvre fascinante, qui lui a valu de nombreuses récompenses, dont le prix Pictet en 2015, et des expositions dans le monde entier. <br/>
            Si elle aborde un large spectre de sujets (<em>Voitures, 2018 ; Robes, 1996 ; Mariées marocaines, 2000 ; Bodybuilders I & II, 1999</em>), la cohérence de son travail est frappante : les prises de vue sont frontales, le cadrage serré, excluant tout élément de décor ou contexte, et le format souvent monumental.`,
        },
        {
            title:`Vers l’abstraction ?`,
            content:`Plus de vingt ans après la série <em>Venise (Miroir)</em>, la question du reflet et de l’abstraction de la lumièreest toujours au centre du travail de Valérie Belin : sa série la plus récente, intitulée <em>Reflection</em> et réalisée pour le Victoria and Albert Museum, transforme des reflets sur des vitrines en percées de lumière abstraites…`,
            noCollapse: true,
        },
    ],


};

